import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VariantsOverviewComponent } from './variants-overview/variants-overview.component';
import { VariantsOverviewBreadcrumbResolver } from './variants-overview/variants-overview-breadcrumb.resolver';

const routes: Routes = [
  {
    path: '',
    component: VariantsOverviewComponent,
  },
  {
    path: ':cartridgeId',
    resolve: {
      subBreadcrumbs: VariantsOverviewBreadcrumbResolver,
    },
    loadChildren: () =>
      import('@markant-platform/cartridges-backoffice/feature-organizations-with-usage-right').then(
        m => m.CartridgeBackofficeFeatureOrganizationsWithUsageRightModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CartridgesBackofficeFeatureVariantsOverviewRoutingModule {}
